import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import EnterprisePlanForm from '../EnterprisePlanForm';
import form from '../../forms/enterprisePlanForm';
import { HandySvg } from 'handy-svg';

const EnterprisePlan = ({ plan, user }) => {
  useEffect(() => {
    if (user) {
      form.update({
        "first_name": user.first_name,
        "last_name": user.last_name,
        "country": user.country,
        "email": user.email,
        "company": user.company
      });
    } else {
      form.reset();
    }
  });

  return (
    <>
      <HandySvg
        width={45}
        height={45.5}
        src={"/static/vq-probe.svg"}
        className="EnterprisePlanForm__logo"
      />
      <h1 className="EnterprisePlanForm__text">{plan.product_name} <span className="bold">{plan.product_mode}</span></h1>
      <EnterprisePlanForm form={form} plan={plan} />
    </>
  )
}

export default observer(EnterprisePlan);
